export enum DateRangesTypes {
  YDY = 'ydy',
  LWK = 'lWk',
  LMN = 'lMn',
  L7 = 'l7',
  L30 = 'l30',
  TMN = 'tMn',
  ALL = 'all',
  CUSTOM = 'custom',
}

export interface DateRangeOption {
  type: DateRangesTypes;
  heapName: string;
  active: boolean;
  value: Date[];
}

export enum SideEnum {
  left = 'left',
  right = 'right',
}

export enum CompareTypes {
  PREVIOUS_PERIOD = 'previous-period',
  PREVIOUS_YEAR = 'previous-year',
  CUSTOM = 'custom',
}

export interface CalendarOptions {
  linkedCalendars: boolean;
  dateLimit: number | null;
}
export interface Calendar {
  grid: Date[][];
  firstDay: Date;
  lastDay: Date;
}
export interface CalendarState {
  calCols: number[];
  calRows: number[];
  calendar: Calendar;
  classes: Record<number, Record<string | number, string>>;
  dayOfWeek: number;
  daysInLastMonth: number;
  daysInMonth: number;
  dropdowns?: Dropdown;
  firstDay: Date | null;
  hour: number;
  lastDay: Date | null;
  lastMonth: number;
  lastYear: number;
  maxDate: Date | null;
  minDate: Date | null;
  minute: number;
  month: number;
  second: number;
  year: number;
}

export interface Dropdown {
  currentMonth: number;
  currentYear: number;
  inMaxYear: boolean;
  inMinYear: boolean;
  maxYear: number;
  minYear: number;
  monthArrays: number[];
  yearArrays: number[];
}

export interface Locale {
  daysOfWeek: string[];
  monthNames: string[];
  format: 'dd/MM/yyyy' | 'MM/dd/yyyy';
  displayFormat: string;
  firstDay: number;
}
